module.exports = __webpack_public_path__ + "img/Replace Tyre.2e3f91d1.png";